import { Stack, type StackProps } from '@mui/material'
import { LoadingSkeleton, tokens } from 'ComponentLibrary'

type HeaderNavButtonSkeletonsProps = Pick<StackProps, 'alignSelf' | 'flexGrow'>

export function ValuationPageNavButtonsLoad({ alignSelf, flexGrow }: HeaderNavButtonSkeletonsProps) {
    return (
        <Stack direction="column" alignItems="flex-end" alignSelf={alignSelf} flexGrow={flexGrow} gap={tokens.SizingSpacing150}>
            <LoadingSkeleton variant="rounded" height="24px" width="150px" />
            <LoadingSkeleton variant="rounded" height="24px" width="150px" />
            <LoadingSkeleton variant="rounded" height="24px" width="150px" />
        </Stack>
    )
}
